import { useNavigate, useLocation } from 'react-router-dom';
import { useQueryClient } from '@tanstack/react-query';
import CreateWorksheetFlow from './CreateWorksheetFlow';
import CloudBand from '../../components/common/CloudBand';
import s from './CharacterSelectPage.module.css';

export default function CharacterSelectPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const queryClient = useQueryClient();

  // Extract pre-selected character IDs from StoryReview navigation
  const storyChars = location.state?.story?.characters;
  const preselected = location.state?.preselected;
  const initialCharacterIds = storyChars
    ? storyChars.slice(0, 5).map((c) => c.id || c.char)
    : preselected
    ? preselected.map((c) => c.id || c.char)
    : undefined;

  // If coming from StoryReview with pre-selected chars, start at step 2
  const initialStep = initialCharacterIds ? 2 : 1;

  return (
    <main className={s.page}>
      <CloudBand variant="teal" className={s.cloudBand} />
      <div className={s.content}>
        <CreateWorksheetFlow
          initialCharacterIds={initialCharacterIds}
          initialStep={initialStep}
          isModal={false}
          onClose={() => navigate('/workbook')}
          onComplete={(worksheet) => {
            queryClient.invalidateQueries({ queryKey: ['childWorksheets'] });
            queryClient.invalidateQueries({ queryKey: ['childCharacters'] });
            queryClient.invalidateQueries({ queryKey: ['curriculumCharacters'] });
            queryClient.invalidateQueries({ queryKey: ['learnerProfile'] });
            const worksheetId = worksheet.id || worksheet.worksheet_id;
            navigate(`/workbook/preview/${worksheetId}`, {
              replace: true,
              state: { worksheet },
            });
          }}
        />
      </div>
    </main>
  );
}
